import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { entitiesApi } from '@sophocles/features/entities/entitiesApi';
import rootReducer from '@sophocles/rootReducer';

const store = configureStore({
  reducer: rootReducer,
  // Large parts of the state tree are still Immutable.js Maps/Lists; the default
  // serializable/immutable dev checks deep-walk the whole tree on every dispatch
  // and stall the dev app, so they stay off until that state is plain JS.
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }).concat(entitiesApi.middleware),
});

setupListeners(store.dispatch);

export default store;
